<form class="field-dialog__content__scroll p-24" fxLayout="column" name="form" fusePerfectScrollbar>
  <div *ngIf="!tasks.length" fxLayout="column" fxLayoutAlign="center center">
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="no-results-icon">assignment</mat-icon>
    </p>
    <div fxFlex="100" fxLayout="row">
      <span class="h3">{{ 'MAINTENANCES.TABS.TASKS.WITHOUT_TASKS' | translate }}</span>
    </div>
  </div>

  <div *ngIf="tasks.length">
    <div class="card" *ngFor="let task of tasks; let $index = index">
      <div class="card__label" fxLayout="row">
        <label>{{ 'MAINTENANCES.TABS.TASKS.CARD_TITLE' | translate: { index: $index + 1 } }}</label>
        <label class="archived-badge" *ngIf="task.archived">{{ 'MAINTENANCES.TABS.TASKS.ARCHIVED' | translate }}</label>
      </div>

      <div class="card__item">
        <show-data-input fxFlex="34" label="{{ 'MAINTENANCES.TABS.TASKS.CREATED_AT' | translate }}">
          {{ task.createdAt | date: 'dd/MM/yyyy HH:mm' }}
        </show-data-input>

        <show-data-input fxFlex="33" label="{{ 'MAINTENANCES.TABS.TASKS.EMPLOYEE' | translate }}">
          {{ task.employee?.name || 'Sem colaborador' }}
        </show-data-input>

        <show-data-input
          fxFlex="33"
          label="{{ 'MAINTENANCES.TABS.TASKS.STATUS' | translate }}"
          class="{{ task.status }}-fg"
        >
          {{ task.status | enum: 'task_status' }}
        </show-data-input>
      </div>

      <div class="card__item">
        <show-data-input fxFlex="34" label="{{ 'MAINTENANCES.TABS.TASKS.SCHEDULED_DATE' | translate }}">
          {{ task.scheduled?.date | timezoneDate: task.scheduled?.time:task.timezone }}
        </show-data-input>

        <show-data-input fxFlex="33" label="{{ 'MAINTENANCES.TABS.TASKS.STARTED_AT' | translate }}">
          {{ task.startedAt | date: 'dd/MM/yyyy HH:mm' }}
        </show-data-input>

        <show-data-input fxFlex="33" label="{{ 'MAINTENANCES.TABS.TASKS.COMPLETED_AT' | translate }}">
          {{ task.completedAt | date: 'dd/MM/yyyy HH:mm' }}
        </show-data-input>
      </div>

      <div class="card__item" *ngIf="task.statusDescription">
        <show-data-input fxFlex="100" label="{{ 'MAINTENANCES.TABS.TASKS.COMMENT' | translate }}">
          {{ task.statusDescription }}
        </show-data-input>
      </div>

      <div class="card__item">
        <show-data-input fxFlex="34" label="{{ 'MAINTENANCES.TABS.TASKS.RATING' | translate }}">
          <stars *ngIf="task.rating?.stars" [stars]="task.rating.stars"></stars>
          <span *ngIf="!task.rating?.stars">
            {{ 'MAINTENANCES.TABS.TASKS.NOT_RATED' | translate }}
          </span>
        </show-data-input>

        <show-data-input fxFlex="66" label="{{ 'MAINTENANCES.TABS.TASKS.RATE_COMMENT' | translate }}">
          {{ task.rating?.comments || ('MAINTENANCES.TABS.TASKS.NO_COMMENT' | translate) }}
        </show-data-input>
      </div>
    </div>
  </div>
</form>
